import ApiService from '../api.service'

export type Segmento = {
    id: number
    nome: string
}

type SegmentoParams = {
    search?: string
}

export const segmentos_api = new ApiService<never, Segmento, SegmentoParams>(
    'segmentos',
)
